module.exports = __webpack_public_path__ + "img/icon_5.a1aadc08.png";